<template>
    <yams-template>
        <template #header>
            <div class="mr-5">
                <h4 class="text-primary font-weight-bold">Paiements ({{ lines }})</h4>
            </div>
            <div class="mr-4">
                <NavOperations></NavOperations>
            </div>
            <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
                <button type="button" class="btn " @click.prevent="changeAffichage('table')"
                    :class="{ 'active': affichage === 'table' }">
                    <i class="fa-solid fa-bars"></i>
                </button>
                <button type="button" class="btn " @click.prevent="changeAffichage('card')"
                    :class="{ 'active': affichage === 'card' }">
                    <i class="fa-solid fa-border-all"></i>
                </button>
            </div>
        </template>
        <template #content>
            <div class="card mb-5">
                <div class="card-body p-1">
                    <DataTableBackend :key="key" url="/api/paiements"
                        :columns="columns" :view-mode="affichage" :table="table" @row-click="openShowModal"
                        @set-selected-rows="getSelection" v-on:set-total-records="updateLines">
                    </DataTableBackend>
                </div>
            </div>
        </template>
    </yams-template>
</template>

<script>
import $ from "jquery"
import NavOperations from '../NavOperations.vue';
import { defineComponent, defineAsyncComponent } from 'vue';
const ShowPaiement = defineAsyncComponent(() => import('./ShowPaiement.vue'));
const CreatePaiement = defineAsyncComponent(() => import('./CreatePaiement.vue'));

export default defineComponent({
    name: 'IndexPaiement',
    components: { NavOperations },
    data() {
        return {
            key: 1,
            lines: 0,
            table: 'paiements',
            affichage: "table",
            selection: [],
            baseUrl: this.$store.getters.apiCourses,
            columns: [
                {
                    key: 'date_operation',
                    label: 'Date',
                    format: 'date',
                    exportable: true
                },
                {
                    key: 'client_nom_complet',
                    label: 'Client',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'course_details',
                    class: 'bg-secondary p-1 rounded text-white text-center',
                    exportable: true,
                    label: 'Course',
                    sortable: true
                },

                {
                    key: 'libelle',
                    label: 'Libelle',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'mode',
                    label: 'Mode',
                    exportable: true,
                    sortable: true
                },
                {
                    key: 'montant',
                    label: 'Montant',
                    format: 'money',
                    exportable: true
                },
                {
                    key: 'statut',
                    label: 'Statut',
                    format: 'state'
                },
            ]
        };
    },
    methods: {
        openShowModal(objData) {
            this.$dialog.open(ShowPaiement, {
                props: {
                    header: "Paiement ID" + objData.id,
                    style: {
                        width: '40vw'
                    },
                    modal: true
                },
                data: objData
            });
        },
        openCreateModal() {
            this.$dialog.open(CreatePaiement, {
                props: {
                    header: "Nouveau paiement",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
                data: this.course_id
            });
        },
        deleteLine(id) {
            if (!window.confirm("Etes vous sur de vouloir supprimer ?")) {
                return
            }
            this.isLoading = true
            this.axios.post(this.$store.getters.apiCourses + '/api/paiements/' + id + '/destroy').then(response => {
                this.isLoading = false
                if (response.data.success === true) {
                    $('#refresh' + this.table).click()
                    $('#refreshcourses').click()
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        deleteGroup(selection) {
            if (!window.confirm("Etes vous sur de vouloir supprimer ?")) {
                return
            }

            this.isLoading = true
            let selectedLines = []
            for (let index = 0; index < selection.length; index++) {
                const element = selection[index];
                selectedLines.push(element.id)
            }

            this.axios.post(this.$store.getters.apiCourses + '/api/paiements/destroy-group', { selected_lines: selectedLines }).then((response) => {
                this.isLoading = false
                if (response.data.success === true) {
                    $('#refresh' + this.table).click()
                    for (let index = 0; index < response.data.message.length; index++) {
                        const element = response.data.message[index];
                        this.$toast.add({
                            severity: element.severity,
                            detail: element.value,
                            life: parseInt(5000 * (index + 1))
                        });
                    }
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        changeAffichage(type) {
            this.affichage = type;
            this.key++
        },
        getSelection(selection) {
            this.selection = selection
        },
        updateLines(nb_lines) {
            this.lines = nb_lines
        }
    },
});
</script>